document.addEventListener('alpine:init', () => {
  Alpine.data('CartUpsell', () => ({
    isAddingUpsell: false,

    async addUpsellToCart(variantId) {
      if (this.isAddingUpsell) return;
      
      this.isAddingUpsell = true;
      const sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

      const config = fetchConfigDefaults('javascript');
      config.body = JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }],
        sections,
        sections_url: window.location.pathname
      });

      try {
        const response = await fetch(theme.routes.cart_add_url, config);
        const data = await response.json();

        if (data.status === 422) {
          console.error('Error adding upsell product');
        } else {
          document.body.dispatchEvent(
            new CustomEvent('shapes:modalcart:afteradditem', {
              bubbles: true,
              detail: { response: data }
            })
          );
        }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        this.isAddingUpsell = false;
      }
    }
  }));
});